const INPUT_RATING_IDS = [
    'cr_stars-selection__input--1',
    'cr_stars-selection__input--2',
    'cr_stars-selection__input--3',
    'cr_stars-selection__input--4',
    'cr_stars-selection__input--5',
] as const;
export type RatingInputId = (typeof INPUT_RATING_IDS)[number];

export const isRatingInputId = (inputId: string): inputId is RatingInputId => INPUT_RATING_IDS.includes(inputId as RatingInputId);
